import { FC } from "react";
import Container from "react-bootstrap/Container";
import { FaPlus } from "react-icons/fa";
import { useRouteParams } from "app/route/route";
import { newReportVersionRoute, reportVersionsRoute } from "app/route/Routes";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { ReportVersionsTable } from "app/component/report-version/ReportVersionsTable";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { Toolbar, ToolbarButtons, ToolbarTitle } from "app/component/util/Toolbar";
import { ButtonLink } from "app/component/button/ButtonLink";
import { useReportIdPermissions } from "app/api/graph/hook/use-report-permissions";
import { reportGraphId } from "app/api/graph/helpers";

export const ReportVersionsScreen: FC = () => {
    const { reportId } = useRouteParams(reportVersionsRoute);
    const permissions = useReportIdPermissions(reportGraphId(reportId));

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={reportVersionsRoute} />
                <Toolbar>
                    <ToolbarTitle>
                        <h1>Versions</h1>
                    </ToolbarTitle>
                    <ToolbarButtons>
                        {permissions.canCreateReportVersion ? (
                            <ButtonLink to={newReportVersionRoute.build({ reportId })} variant="success">
                                <FaPlus /> New version
                            </ButtonLink>
                        ) : null}
                    </ToolbarButtons>
                </Toolbar>
                <ReportVersionsTable reportId={reportId} />
            </Container>
        </NavigationScreen>
    );
};
